import { render, staticRenderFns } from "./NotePreviewer.vue?vue&type=template&id=a0febede&scoped=true&"
import script from "./NotePreviewer.vue?vue&type=script&lang=js&"
export * from "./NotePreviewer.vue?vue&type=script&lang=js&"
import style0 from "./NotePreviewer.vue?vue&type=style&index=0&id=a0febede&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0febede",
  null
  
)

export default component.exports